import React from "react";
import s from "./style.module.scss";
import { PageWrapper } from "../PageWrapper";
import { GreenCheck } from "../Icons/GreenCheck";
import { useSectionsData } from "../../utils/useSectionsData";
import { getBrandName } from "../../utils/helpers.ts";
import glideImage from "../../utils/useGlideImage.ts";

interface ProductPointsProps {
  tr_title: string;
  tr_text: string;
}

interface IngredientsProps {
  tr_title: string;
  tr_description: string;
  icon: string;
}

export const Ingredients = () => {
  const sections = useSectionsData();
  const brandName = getBrandName();
  const ingredientsSection = sections.pp_v7_ingredients_section;
  const heading = ingredientsSection.tr_section_heading;
  const ingredients = ingredientsSection?.ingredients_repeater;
  const productPoints = ingredientsSection?.product_points;
  const table =
    ingredientsSection?.table_image ||
    `${window.template_root}/v1/ingredients/SupplementFacts.png`;

  return (
    <PageWrapper backgroundColor="section_white">
      <div className={s.ingredients}>
        <div
          className={s.ingredients__title}
          dangerouslySetInnerHTML={{ __html: heading }}
        ></div>
        <div className={s.ingredients__organicGroup}>
          {ingredients.map((ingredient: IngredientsProps, index: number) => (
            <div
              key={index}
              className={s.ingredients__organicGroup__ingredient}
            >
              <img
                src={glideImage(ingredient.icon, { w: 300, h: 300 })}
                alt={brandName}
                width={300}
                height={300}
              />
              <div className={s.ingredients__organicGroup__texts}>
                <div className={s.ingredients__organicGroup__title}>
                  {ingredient.tr_title}
                </div>
                <div
                  className={s.ingredients__organicGroup__subtitle}
                  dangerouslySetInnerHTML={{
                    __html: ingredient.tr_description,
                  }}
                />
              </div>
            </div>
          ))}
        </div>
        <div className={s.ingredients__points}>
          <div className={s.ingredients__pointsList}>
            {productPoints.map((point: ProductPointsProps, index: number) => (
              <span key={index}>
                <div className={s.ingredients__pointsList__title}>
                  <GreenCheck />
                  {point.tr_title}
                </div>
                <div
                  className={s.ingredients__pointsList__description}
                  dangerouslySetInnerHTML={{ __html: point.tr_text }}
                />
              </span>
            ))}
          </div>
          <img src={table} alt={brandName} width={548} height={562} />
        </div>
      </div>
    </PageWrapper>
  );
};
